var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 52,
    viewBox: "0 0 84 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2439 8.87762C81.276 5.76214 78.4337 3.31383 74.8173 2.47986C68.2693 0.966797 42 0.966797 42 0.966797C42 0.966797 15.731 0.966797 9.18276 2.47986C5.56637 3.31383 2.72441 5.76214 1.75634 8.87762C5.25739e-07 14.5188 0 26.2957 0 26.2957C0 26.2957 5.25739e-07 38.0726 1.75634 43.7139C2.72441 46.8293 5.56637 49.2776 9.18276 50.1114C15.731 51.6246 42 51.6246 42 51.6246C42 51.6246 68.2693 51.6246 74.8173 50.1114C78.4337 49.2776 81.276 46.8293 82.2439 43.7139C84.0003 38.0726 84.0003 26.2957 84.0003 26.2957C84.0003 26.2957 83.9932 14.5188 82.2439 8.87762Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5918 37.1502L55.4147 26.2967L33.5918 15.4431V37.1502Z",
    fill: "#770D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.78441748da7d5b002db656e1ea0a2cb0.svg";
export { ForwardRef as ReactComponent };